import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";

const PassWord = () => {
    const [changePasswordUser, setChangePasswordUser] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    const [statusChangepassword, setStatusChangePassword] = useState('')
    const [showStatus, setShowStatus] = useState(false);

    const { apiUrl } = useSelector(state => state.api);

    const changePassword = async (e) => {
        e.preventDefault()
        const data = { ...changePasswordUser };
        try {
            const response = await axios.put(`${apiUrl}/myaccount/password`, data, {
                headers: { token: localStorage.getItem('token') }
            });
            console.log(response);
        } catch (err) {
            console.error('err.message', err.message);
            setStatusChangePassword(err.response.data)
            setShowStatus(true);
            setTimeout(() => setShowStatus(false), 3000);
            // console.error("err.response", err.response.data); // Log the response data to the console

        }
    }

    const handleChangePasswordUser = (event) => {
        setChangePasswordUser({
            ...changePasswordUser,
            [event.target.name]: event.target.value,
        });
    };


    return (
        (<div className="col-md-10 bg-light  ">
            <div className="row ">

                <div class="col-md-12 text-center pt-5 pb-5 ">
                    <form onSubmit={(e) => changePassword(e)}>

                        <div class="row d-flex justify-content-center align-items-center">
                            <div class="col-3 pt-3 pb-3 text-center ">
                                <label for="oldPassword" class="form-label">Current password:</label>
                            </div>
                            <div class="col-9 col-md-7 pt-2 pb-2">
                                <input type="password" class="form-control" id="oldPassword" name="oldPassword"
                                    value={changePasswordUser.oldPassword}
                                    onChange={(e) => handleChangePasswordUser(e)}
                                    required
                                />
                            </div>
                        </div>

                        <div class="row d-flex justify-content-center align-items-center">
                            <div class="col-3 pt-3 pb-3 text-center">
                                <label for="newPassword" class="form-label">New password:</label>
                            </div>

                            <div class="col-9 col-md-7 pt-2 pb-2">
                                <input type="password" class="form-control" id="newPassword" name="newPassword"
                                    onChange={handleChangePasswordUser}
                                    value={changePasswordUser.newPassword}
                                    required
                                />
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center align-items-center">
                            <div class="col-3 pt-3 pb-3 text-center">
                                <label for="confirmPassword" class="form-label">Confirm password:</label>
                            </div>
                            <div class="col-9 col-md-7 pt-2 pb-2">
                                <input type="password" class="form-control" id="confirmPassword" name="confirmPassword"
                                    onChange={handleChangePasswordUser}
                                    value={changePasswordUser.confirmPassword}
                                    required
                                />
                            </div>
                        </div>

                        <div className="col-11 d-flex justify-content-end m-2">
                            {showStatus && <div class="statusChangePass justify-content-between m-2"> {statusChangepassword}</div>}
                            <button type="submit" className="btn btn-primary">Save</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>)
    )
}
export default PassWord;